import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  buttons: {
    width: "100%",
    height: 72,
    display: "flex",
    justifyContent: "flex-end",
    position: "fixed",
    padding: "16px 48px 0 0",
    bottom: 0,
    right: 0,
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    background: "white",
  },
  save: {
    marginLeft: 16,
  },
}));